import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function MaternidadSagrada() {
  const { t, i18n } = useTranslation();

  // Checkout de Hotmart de Maternidad Sagrada segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/K107377078G'
      : 'https://pay.hotmart.com/P107376963V';

  const heroImage = i18n.language === 'en'
    ? 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/846977ee-6ecf-4b38-a5ce-9ac1492b2b53_compressed_ChatGPT-Image-18-ago-2026-06_16_23-p.m.-4.webp'
    : 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/7d88976d-7441-439c-bad6-713f53d4dd25_compressed_ChatGPT-Image-18-ago-2026-06_12_25-p.m.-4.webp';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('best_seller.badge')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('bestseller_maternidad.hero_title1')}
                <br />
                <span className="font-bold">{t('bestseller_maternidad.hero_title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('bestseller_maternidad.hero_subtitle')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-book-open-line text-xs" />
                  {t('bestseller_maternidad.badge_tag')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-download-cloud-line text-xs" />
                  {t('best_seller.download')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('best_seller.unlimited')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$14.99</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('best_seller.price_label')}</span>
              </div>
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt={t('bestseller_maternidad.hero_image_alt')}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-moon-clear-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-xl md:text-2xl text-cream leading-relaxed mb-6">
            {t('bestseller_maternidad.dark_quote')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-3xl mx-auto">
          <div className="w-14 h-14 rounded-2xl bg-terracotta/15 flex items-center justify-center mx-auto mb-8">
            <i className="ri-road-map-line text-2xl text-terracotta" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight text-center mb-10">
            {t('bestseller_maternidad.what_title')}
          </h2>
          <div className="space-y-5">
            {[1, 2, 3, 4].map((n) => (
              <div
                key={n}
                className="bg-cream rounded-2xl p-5 md:p-6 border border-sand/30 flex items-start gap-4 md:gap-5"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-terracotta flex items-center justify-center flex-shrink-0">
                  <span className="font-serif text-lg md:text-xl font-bold text-white">
                    {String(n).padStart(2, '0')}
                  </span>
                </div>
                <div>
                  <h3 className="font-serif text-lg md:text-xl font-bold text-[#8B6F5C] mb-1">
                    {t(`bestseller_maternidad.capitulo_${n}_title`)}
                    {t(`bestseller_maternidad.capitulo_${n}_subtitle`) && (
                      <span className="font-sans text-sm font-normal text-[#5C4A3A] ml-2">
                        {t(`bestseller_maternidad.capitulo_${n}_subtitle`)}
                      </span>
                    )}
                  </h3>
                  <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                    {t(`bestseller_maternidad.capitulo_${n}_desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-pulse-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            {t('bestseller_maternidad.quote')}
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            {t('bestseller_maternidad.quote_author')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('bestseller_maternidad.cta_title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('bestseller_maternidad.cta_desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$14.99</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base font-semibold hover:bg-brown transition-colors duration-300 mb-4 cursor-pointer"
          >
            {t('bestseller_maternidad.cta_button')}
            <i className="ri-arrow-right-line" />
          </a>
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('best_seller.cta_footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}